import "./header.css";
import { Carousel } from "react-bootstrap";
import img1 from "../../assets/img1.jpg";
import img2 from "../../assets/img2.jpg";

export const Header = () => {
  return (
    <div className="header">
      <header>
        <div className="image-carousel">
          <Carousel prevIcon nextIcon fade>
            <Carousel.Item>
              <Carousel.Caption>
                <h3>Welcome to Our Hotel</h3>
                <p>Experience luxury and comfort like never before.</p>
              </Carousel.Caption>
              <img className="d-block " src={img1} alt="First slide" />
            </Carousel.Item>
            <Carousel.Item>
              <img className="d-block " src={img2} alt="Second slide" />
              <Carousel.Caption>
                <h3>Fine Dining</h3>
                <p>Savor delicious meals crafted by top chefs.</p>
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </div>
      </header>
    </div>
  );
};
